import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Col, Row, Form, FormGroup, Input, Button } from "reactstrap";
import { toast } from "react-toastify";
import AuthCardLayout from "./AuthCardLayout";
import ForgetPasswordForm from "./ForgetPasswordForm";
import PasswordReset from "./PasswordReset";
import authenticationService from "../../services/authenticationService";
import useFullPageLoader from "../../hooks/useFullPageLoader";

const ForgetPassword = () => { 
  const [isResetPasswordActive, setIsResetPasswordActive] = useState(false);
  const [showSecurityQuestion, setShowSecurityQuestion] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [questions, setQuestions] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [email, setEmail] = useState("");
  const history = useHistory();

  const isApiPlusExist = sessionStorage.getItem("api_plus_plus")
    ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
    : false;

  const validateQuestions = (e) => {
    e.preventDefault();
    if (selectedQuestion && answer) {
      showLoader();
      let body = {
        answer: answer,
        queId: selectedQuestion,
        username: email,
      };
      authenticationService
        .POST2FAQuestions("forgot_password_arv", body)
         .then((response) => {
    if (response.data.status === "Success") {
      setIsResetPasswordActive(true);
    }
    toast.success(response.data.message.toString());
    hideLoader();
  })
  .catch((error) => {
    if (error.response.data?.attempts === 5 || error.response.data?.errorCode === "LOCKED") {
      toast.error("Too many attempts. Redirecting to login...");
      hideLoader();
     history.push(`${process.env.PUBLIC_URL}/authentication/login`);
      return;
    }
    const resMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    toast.error(resMessage);
    hideLoader();
  });
    }
  };

  return (
    <>
    <AuthCardLayout>
      {isResetPasswordActive ? (
        <PasswordReset />
      ) : showSecurityQuestion ? (
        <Row
          style={{ display: "grid", justifyContent: "center", padding: "2%" }}
          className="text-center mb-5"
        >
          <Col>
            <div style={{ marginBottom: "2em" }}>
              <h4 className="mb-0">Account Recovery</h4>
              <p style={{ fontSize: "0.8em" }} className="mt-2">
                🔐 Please select a security question from the dropdown to proceed with account recovery.
              </p>
            </div>

            <Form onSubmit={validateQuestions}>
              <FormGroup className="mb-3">
                <Input
                  id="exampleSelect"
                  name="select"
                  type="select"
                  required
                  value={selectedQuestion}
                  onChange={(e) => setSelectedQuestion(e.target.value)}
                >
                  <option value="" disabled>
                    -- Select a question --
                  </option>
                  {questions.map((question, index) => (
                    <option key={index} value={question.que_id}>
                      {question.que_text}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup className="mb-3">
                <Input
                  required
                  placeholder="Answer"
                  value={answer}
                  onChange={({ target }) => setAnswer(target.value)}
                  type="text"
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Button color="primary" block className="mt-3" type="submit">
                  Confirm & Proceed
                </Button>
              </FormGroup>
            </Form>
          </Col>
        </Row>
      ) : (
        <>
          <div
            style={{
              display: "grid",
              justifyContent: "center",
              padding: "5%",
            }}
            className="text-center"
          >
            <h5 className={'mb-0 ${isApiPlusExist && "sai_light_text"}'}>
              Forgot your password?
            </h5>
            <small className="mt-2">
              Enter your <b>email</b> and we'll send you a <b>verify code</b> to your <b>email address</b>.
            </small>          
            <ForgetPasswordForm
             setQuestions={setQuestions}
             setShowSecurityQuestion={setShowSecurityQuestion}
             setIsResetPasswordActive={setIsResetPasswordActive}
             email={email}
             setEmail={setEmail}
            />

          </div>
          <Row className="g-4 text-center text-md-start d-flex justify-content-center mt-4">
            <Col xs="auto">
              <h4 className={'fs--1 text-600 text-lowercase'}>
                <Button
                  color="link"
                  className={'p-0 ${isApiPlusExist && "sai_light_text"}'}
                  onClick={() => history.push(`${process.env.PUBLIC_URL}/authentication/login`)}
                >
                  Go To Login Page 
                </Button>
              </h4>
            </Col>
          </Row>
        </>
      )}
      {loader}
    </AuthCardLayout>
    </>
  );
};

export default ForgetPassword;